"use client";
import { jsx as s, jsxs as d, Fragment as f } from "react/jsx-runtime";
import a from "clsx";
import U from "next/link";
import { memo as u } from "react";
import { Box as i } from "../base/Base.js";
import '../../assets/UserCoins.css';const y = "_set_1ggxc_1", j = "_item_1ggxc_8", C = "_classic_1ggxc_11", L = "_white_1ggxc_11", S = "_small_1ggxc_13", b = "_violet_1ggxc_18", A = "_orange_1ggxc_25", B = "_gray_1ggxc_32", E = "_red_1ggxc_39", F = "_notice_1ggxc_46", T = "_text_1ggxc_53", k = "_count_1ggxc_59", q = "_icon_1ggxc_69", z = "_mix_1ggxc_90", t = {
  set: y,
  item: j,
  classic: C,
  white: L,
  small: S,
  violet: b,
  orange: A,
  gray: B,
  red: E,
  notice: F,
  text: T,
  count: k,
  icon: q,
  mix: z
}, D = u(
  ({ className: e, children: n }) => /* @__PURE__ */ s(i, { row: !0, gap: 12, className: a(t.set, e), children: n })
);
D.displayName = "UserCoinsSet";
const G = u(
  ({
    count: e,
    text: n,
    type: c = "classic",
    color: h = "white",
    icon: r,
    className: p,
    href: _,
    scroll: w = !0,
    onClick: o,
    ...N
  }) => {
    const v = (m) => {
      var x;
      const l = m.currentTarget.getAttribute("data-event");
      l && ((x = window == null ? void 0 : window.dataLayer) == null || x.push({
        event: l
      })), o == null || o(
        m
      );
    }, g = /* @__PURE__ */ d(
      i,
      {
        row: c === "small",
        gap: c === "small" ? 8 : 4,
        className: a(t.item, t[c], t[h]),
        children: [
          /* @__PURE__ */ d(i, { gap: 4, row: !0, center: !0, children: [
            c !== "mix" && /* @__PURE__ */ s("span", { className: t.count, children: e }),
            r && /* @__PURE__ */ s(
              "div",
              {
                className: a("material-icons", t.icon),
                "data-icon": r
              }
            ),
            c === "mix" && /* @__PURE__ */ s("span", { className: t.count, children: e })
          ] }),
          /* @__PURE__ */ s("span", { className: t.text, children: n })
        ]
      }
    );
    return _ ? /* @__PURE__ */ s(
      U,
      {
        href: _,
        scroll: w,
        onClick: v,
        className: p,
        ...N,
        children: g
      }
    ) : /* @__PURE__ */ s(f, { children: g });
  }
);
G.displayName = "UserCoins";
export {
  G as UserCoins,
  D as UserCoinsSet
};
